import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RecordService } from 'app/main/services/record.service';
import { DatasetActionContainerService } from 'app/main/services/datasetACS';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'app/main/services/app.service';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CartService } from 'app/main/services/cart.service';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
declare var $: any;

@Component({
	selector: 'product-detail-page',
	templateUrl: './product.component.html',
	styleUrls: ['./product.component.scss']
})
export class ProductPageComponent implements OnInit, AfterViewInit{

	@Input() preview: any;

	formGroup: FormGroup;

	constructor(
		public recordService: RecordService, 
		public datasetACS: DatasetActionContainerService,
		public appService: AppService,
		protected activatedRoute: ActivatedRoute,
		protected router: Router,
		private fb: FormBuilder,
		public translate: TranslateService,
		public cartService: CartService,
		private http: HttpClient) {}

	ngOnInit(): void {
		this.onLoaded();

		this.formGroup = this.fb.group({
			ADT: new FormControl(1),
			date: new FormControl(moment().format('DD/MM/YYYY'))
		});

		this.formGroup.valueChanges.subscribe(formData => {
			/**
			 * set http params
			 */
			this.recordService.setExtraParams(formData);
			/**
			 * reload data
			 */
			this.recordService.reload()
			.subscribe((preview: any) => {
				this.preview = preview;
			});
		});
	}

	ngAfterViewInit(): void{
		const datePicker = (<any>$('.date-pick')).datepicker({
			language: this.translate.currentLang,
			beforeShowDay: this.disableDaysDynamic.bind(this),
		});
		// on change date
		datePicker.on('changeDate', (e) => {
			datePicker.datepicker('hide');
			const date = moment(new Date(e.date));
			/**
			 * set new date
			 */
			this.formGroup.get('date').setValue(date.format('DD/MM/YYYY'));
		});
		// on show
		datePicker.on('show', () => {
			$('.prev').text('');
			$('.next').text('');
			$('.date-pick-wrapper').addClass('opened');
		});
		// on hide
		datePicker.on('hide', () => $('.date-pick-wrapper').removeClass('opened'));

		setTimeout(() => $('.tickets-popup > *').on('click', (event) => event.stopPropagation()));
	}

	disableDaysDynamic(date: Date): boolean{
		if (!date) return;
		date.setDate(date.getDate()+1);
		return date >= new Date();
	}

	addToCart(): void{
		const fields = this.formGroup.controls;
		// loading while adding to cart
		this.cartService.addToCartLoading.next(true);
		// make call
		const call = this.cartService.makeCall(this.cartService.datasetService.post('/cart/create-or-update/' + this.product.id, {
			target: 'product',
			date: fields['date'].value,
			contextual_domain_id: this.product.domain.id,
			display_name_item: this.product.description,
			master_image: this.product?.language_contents?.master_image_id,
			product_id: this.product.id,
			allotment_type: this.product.allotment_type,
			participants: {
				adt_counter: this.formGroup.controls['ADT'].value,
				chd_counter: 0,
				inf_counter: 0,
				snr_counter: 0
			}
		}));
		// subscribe
		call.subscribe(() => {
			this.cartService.addToCartLoading.next(false);
			this.router.navigate(['/d', this.appService.domainId, 'cart']);
		});;
	}

	increment(): void{
		const field = this.formGroup.controls['ADT'];
		field.setValue(field.value + 1);
	}

	decrement(): void{
		const field = this.formGroup.controls['ADT'];
		if (field.value == 1) return;
		field.setValue(field.value - 1);
	}

	protected onLoaded(): void{
		this.translate
		.use(this.lang)
		.subscribe(() => {
			this.appService.setLanguages(this.product?.active_language_codes);
			this.appService.loadingLanguages.next(false);
		});
	}

	get lang(): string{
		return this.preview.lang;
	}

	get product(): any{
		return this.preview.response.product;
	}
}
